import React, { useState, useEffect } from 'react'
import { Box, Flex, Select, Group, Button } from '@mantine/core'
import { useDebouncedCallback } from '@mantine/hooks'
import { getAllCountryList } from '../../../services/location'
import LoadingData from '../../ui/LoadingData'

const defaultParams = {
  'page[num]': 1,
  'page[limit]': 10,
  'filter[status][is]': null,
  'filter[position][is]': null,
  'filter[country_banners][is]': null,
  'filter[user_origin][is]': null,
}

const defaultStatus = [
  {
    label: 'Active',
    value: 'active'
  },
  {
    label: 'Inactive',
    value: 'inactive'
  },
]
const defaultPosition = [
  {
    label: 'Home',
    value: 'home'
  },
  {
    label: 'Top',
    value: 'top'
  },
  {
    label: 'Middle',
    value: 'middle'
  },
  {
    label: 'Bottom',
    value: 'bottom'
  },
  {
    label: 'Middle Full',
    value: 'middle full'
  },
  {
    label: 'Modal 1',
    value: 'modal 1'
  },
  {
    label: 'Modal 2',
    value: 'modal 2'
  },
  {
    label: 'Modal 3',
    value: 'modal 3'
  },
  {
    label: 'Modal 4',
    value: 'modal 4'
  },
  {
    label: 'Modal 5',
    value: 'modal 5'
  },
]

const FormFilterBanners= ({ paramsBanners, applyFilter, onClose }) => {
  const [parameter, setParameter] = useState(defaultParams)
  const [countrySignupUserList, setCountrySignupUserList] = useState([])
  const [countryOriginProductList, setCountryOriginProductList] = useState([])
  const [loadingCountry, setLoadingCountry] = useState(true)

  const handleGetListCountry = useDebouncedCallback(async () => {
    setLoadingCountry(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'fields[country]': 'name',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCountrySignupUserList(remapDataCountry)
      setCountryOriginProductList(remapDataCountry)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCountry(false)
    }
  }, 300)

  useEffect(() => {
    if (paramsBanners !== null) {
      handleSetParams(paramsBanners)
    }
    // eslint-disable-next-line
  }, [paramsBanners])

  useEffect(() => {
    handleGetListCountry()
    // eslint-disable-next-line
  }, [paramsBanners])

  const handleSetParams = (val) => {
    const prevParams = {
      'filter[status][is]':  val['filter[status][is]'],
      'filter[position][is]':  val['filter[position][is]'],
      'filter[country_banners][is]':  val['filter[country_banners][is]'],
      'filter[user_origin][is]':  val['filter[user_origin][is]'],
    }
    setParameter(prevParams)
  }

  const handleChangeFilter = (name, val) => {
    setParameter((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleApplyFilter = (params) => {
    const valueParams = {
      ...params,
      'page[num]': 1,
      'page[limit]': 10,
    }
    applyFilter(valueParams)
    onClose()
  }

  const mappingFormFilter = () => {
    return (
      <Box>
        <Box mb='md'>
          <Select
            name='filter[status][is]'
            value={parameter['filter[status][is]']}
            label='Status'
            data={defaultStatus}
            onChange={(val) => handleChangeFilter('filter[status][is]', val)}
            size='xs'
            clearable
          />
        </Box>
        <Box mb='md'>
          <Select
            name='filter[position][is]'
            value={parameter['filter[position][is]']}
            label='Position'
            onChange={(val) => handleChangeFilter('filter[position][is]', val)}
            data={defaultPosition}
            size='xs'
            clearable
          />
        </Box>
        <Box mb='md'>
          <Select
            name='filter[country_banners][is]'
            value={parameter['filter[country_banners][is]']}
            label='Country Origin Product'
            onChange={(val) => handleChangeFilter('filter[country_banners][is]', val)}
            data={countryOriginProductList}
            searchable
            size='xs'
            clearable
          />
        </Box>
        <Box mb='md'>
          <Select
            name='filter[user_origin][is]'
            value={parameter['filter[user_origin][is]']}
            label='Country Signup User'
            onChange={(val) => handleChangeFilter('filter[user_origin][is]', val)}
            data={countrySignupUserList}
            searchable
            size='xs'
            clearable
          />
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onClose}>Close</Button>
              <Button size='xs' variant="filled" onClick={() => handleApplyFilter(parameter)}>Apply Filter</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }
  return (
    <Box>
      {loadingCountry ? <LoadingData /> : mappingFormFilter()}
    </Box>
  )
}

export default FormFilterBanners